import React from 'react'
import { Card, Box, CardContent } from '@material-ui/core'
import { useStyles } from './styles'

const UserInfoByPlaca = ({ users }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box className={classes.mainContainer}>
          {Array.isArray(users) &&
            users.map((value) => (
                <Box key={Math.random()} className={classes.userContainer}>
                  {Object.entries(value.datos).map((element) => (
                    <Box key={Math.random()} className={classes.container}>
                      <Box className={classes.titles}>
                        <strong>{element[0]?.toUpperCase()}</strong>
                      </Box>
                      <Box className={classes.description}>
                        {element[1][0]?.toUpperCase()}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
        </Box>
      </CardContent>
    </Card>
  )
}

export default UserInfoByPlaca
